/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Upcoming_TasksInputs */

const cs_dashboard_upcoming_tasks = /** @type {(inputs: Dashboard_Upcoming_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dnešní agenda`)
};

const en_dashboard_upcoming_tasks = /** @type {(inputs: Dashboard_Upcoming_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's agenda`)
};

/**
* | output |
* | --- |
* | "Today's agenda" |
*
* @param {Dashboard_Upcoming_TasksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_upcoming_tasks = /** @type {((inputs?: Dashboard_Upcoming_TasksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Upcoming_TasksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_upcoming_tasks(inputs)
	return cs_dashboard_upcoming_tasks(inputs)
});